import { getParameterByName } from './getParameterByName'

export interface ILog {
  title: string
  toBeLogged: unknown
  type?: null | 'error' | 'warning' | 'taboola'
  showDate?: boolean
  color?: { text: string; bg: string }
}

const log = ({ showDate, toBeLogged, type, title, color }: ILog) => {
  let c: string
  switch (type) {
    case 'error':
      c = 'background-color:darkred;color:white;'
      break
    case 'warning':
      c = 'background-color:yellow;color:black;'
      break
    case 'taboola':
      c = 'background-color:#054164;color:white;padding:2px 5px;'
      break
    default:
      c = `background-color:${color?.bg || 'black'};color:${
        color?.text || 'white'
      };`
  }
  if (showDate) {
    const d = new Date()
    console.log(
      `%c${title}`,
      `${c}padding:7px 10px;font-weight:700;font-size:1.1`,
      [d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()].join(
        ':'
      ),
      toBeLogged
    )
  } else {
    console.log(
      `%c${title}`,
      `${c}padding:7px 10px;font-weight:700;font-size:1.1`,
      toBeLogged
    )
  }
}
export const prettyLog = (
  title: string,
  toBeLogged: unknown,
  type?: null | 'error' | 'warning' | 'taboola'
) => {
  log({ title, toBeLogged, type, showDate: false })
}

export const taboolaLog = ({
  toBeLogged,
  type,
  title = 'taboola_log',
  showDate = false,
}: {
  showDate?: boolean
  title?: string
  toBeLogged: unknown
  type?: 'error' | 'warning' | 'taboola' | null
}) => {
  const show =
    getParameterByName(title) === 'true' ||
    sessionStorage.getItem(title) === 'true'
  sessionStorage.setItem(title, String(show))
  if (show) {
    const color = type === 'error' ? 'red' : 'white'
    log({
      title,
      toBeLogged,
      type,
      showDate: showDate,
      color: { bg: '#054164', text: color },
    })
  }
}

export const ottLog = (toBeLogged: unknown, type?: 'error') => {
  const title = 'ott_log'
  const shoe_ott_log =
    getParameterByName(title) === 'true' ||
    sessionStorage.getItem(title) === 'true'
  sessionStorage.setItem(title, String(shoe_ott_log))
  if (shoe_ott_log) {
    const color = type === 'error' ? 'red' : 'white'
    log({
      title,
      toBeLogged,
      type,
      showDate: true,
      color: { bg: '#056447', text: color },
    })
  }
}
